import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const getDigitalsaleForms = async (detailNmaId) => {

    const resp = await api(`/api/jsonws/invoke`, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.digitalsaleform/get-forms': {
                    idSetting: detailNmaId
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();


    return JSON.parse(data);
}